<template>
    <div v-if="offer" class="columns is-centered">
        <div class="column">
            <div class="box has-fill-image font-variant-3">
                <div class="columns" style="align-items:center">
                    <div class="column is-2 is-hidden-mobile has-text-centered has-text-weight-light">
                        <p class="is-size-5">{{days[timestamp.getDay()]}}</p>
                        <p class="is-size-5">{{timestamp.getDate()}}/{{timestamp.getMonth() + 1}}/{{timestamp.getFullYear()}}</p>
                    </div>
                    <div class="column is-4 is-offset-1 has-text-centered has-text-weight-light">
                        <div class="w-icon" v-html="weatherIcon" />
                        <div class="is-size-4 is-uppercase">{{offer.weathertext}}</div>
                        <p class="is-size-7">{{offer.message}}</p>
                    </div>
                    <div class="column is-4 is-offset-1 has-text-centered font-variant-2">
                        <div class="is-size-2 is-uppercase">{{offer.city}}</div>
                        <div class="is-size-5 font-variant-3 is-uppercase">{{offer.location}}</div>
                        <div class="">
                          <span style="font-size:5rem">{{offer.temperature}}</span>
                          <sup class="is-size-1">&deg;</sup>
                        </div>
                        <div class="thermometer">
                          <div class="bulb"></div>
                          <progress class="progress is-small is-danger has-text-white" :value="thermometerValue" max="70" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="column is-5">
            <h1 class="is-size-jumbo has-text-weight-bold has-text-warning">Congrats!</h1>
            <p class="is-size-4 has-text-weight-light">You’ve won {{offer.temperature}}% Paytm cash on  MRP of your Cavin’s Lassi Pack</p>
                <br>
            <button @click="handleClaim" class="button is-danger">Claim PayTM Cash</button>
        </div>
    </div>
</template>

<script>
import API from "../API";
import { TimeLite } from "gsap";

export default {
  name: "Claim",
  data() {
    return {
      days: [
        null,
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      timestamp: 0,
      offer: null,
      baseVal: 0,
      weatherIcon: null,
      thermometerValue: 0
    };
  },
  methods: {
    handleClaim() {
      API.post("claimreward", {
        webview_uid:
          JSON.parse(sessionStorage.getItem("offerData")).webview_uid || 0
      })
        .then(res => {
          this.$router.push({ name: "Acknowledgement" });
        })
        .catch(err => {
          this.$router.push({ name: "Error" });
        });
    }
  },
  watch: {
    baseVal(newValue) {
      TweenLite.to(this.$data, 0.5, { thermometerValue: newValue });
    }
  },
  created() {
    this.offer = JSON.parse(sessionStorage.getItem("offerData"));
    if (this.offer) {
      this.timestamp = new Date(this.offer.epochtime * 1000);
      this.baseVal = this.offer.temperature;
      this.weatherIcon = require(`../assets/${this.offer.weathericon}.svg`);
    } else {
      this.$router.push({
        name: "Error",
        params: { title: "Error ", message: "Unauthorized page access" }
      });
    }
  }
};
</script>

<style lang="scss">
.font-variant-3 {
  font-family: "IBM Plex Sans Condensed";
}
.font-variant-2 {
  font-family: "Anton";
}

.box.has-fill-image {
  background-image: url("../assets/card-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  // background: radial-gradient(
  //   circle at 100%,
  //   rgba(255, 255, 255, 0.5),
  //   rgba(255, 255, 255, 0.25)
  // );
  color: white;
  background-color: transparent;
  padding: 2rem;
}
.ani-el {
  width: 120px;
}

.thermometer {
  position: relative;
  margin: 0 0 0 auto;
  .progress {
    border: 0;
  }
}

.bulb {
  position: absolute;
  top: -0.4rem;
  left: 0rem;
  display: inline-block;
  content: "";
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 50%;
  z-index: 1;
  background-color: #db2559;
  // border: 3px solid white;
}
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
.loader {
  color: #ffffff;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before,
.loader:after {
  position: absolute;
  content: "";
}
.loader:before {
  width: 5.2em;
  height: 10.2em;
  background: #0dc5c1;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
.loader:after {
  width: 5.2em;
  height: 10.2em;
  background: #0dc5c1;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.icon.is-xlarge {
  width: 150px;
  height: 150px;
}

.animate-rotate {
  transform: translate(123px, 17px);
  transform-origin: center center;
  transform-box: fill-box;
  animation: rotate 5s linear infinite;
}

$drop-length: 6;
$star-length: 6;

@for $i from 0 through $drop-length {
  .animate-rain ellipse:nth-child(#{$i}) {
    animation: drops 0.75s #{$i/10}s infinite;
  }
}

@for $i from 0 through $star-length {
  .animate-stars polygon:nth-child(#{$i}) {
    animation: blink 2.5s #{$i/3}s infinite;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes drops {
  0% {
    transform: translateY(0);
    opacity: 1;
    transform: rotate(initial);
  }
  50% {
    opacity: 0.4;
  }
  100% {
    transform: translateY(100px);
    opacity: 0;
    transform: rotate(initial);
  }
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.animate-line {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 5s infinite;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}

sup {
  vertical-align: top;
}

.w-icon {
  height: 200px;
  width: 200px;
  margin: 0 auto;
}

g#rays.animate-rotate {
  transform: translate(123px, 17px);
  transform-origin: center center;
  transform-box: fill-box;
  animation: rotate 15s linear infinite;
}

$cloud-length: 3;
$drop-length: 6;
$flake-length: 3;
$star-length: 6;

.animate-clouds g:nth-child(1) {
  animation: slide 3s ease-out infinite;
}
.animate-clouds g:nth-child(2) {
  animation: slide 3s ease-out 0.5s infinite;
}
.animate-clouds g:nth-child(3) {
  animation: slide 3s ease-out 1s infinite;
}

@for $i from 0 through $drop-length {
  .animate-rain ellipse:nth-child(#{$i}) {
    animation: drops 0.75s #{$i/10}s infinite;
  }
}

@for $i from 0 through $star-length {
  .animate-stars polygon:nth-child(#{$i}) {
    animation: blink 2.5s #{$i/3}s infinite;
  }
}

@for $i from 0 through $flake-length {
  .animate-flakes path:nth-child(#{$i}) {
    animation: drops 2.5s #{$i/3}s infinite;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes slide {
  0% {
    transform: initial;
  }
  50% {
    transform: translateX(15%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes drops {
  0% {
    transform: translateY(0);
    opacity: 1;
    transform: rotate(initial);
  }
  50% {
    opacity: 0.4;
  }
  100% {
    transform: translateY(100px);
    opacity: 0;
    transform: rotate(initial);
  }
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes slide-in-left {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}

@keyframes slide-in-right {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0%);
  }
}

@keyframes appear {
  0% {
    opacity: 0;
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.line-1 {
  animation: slide-in-left 2s ease-out infinite;
}
.line-2 {
  animation: slide-in-right 2s ease-out infinite;
}
.line-3 {
  animation: appear 2s ease-in-out infinite;
}
</style>















// WEBPACK FOOTER //
// src/routes/Claim.vue